import { RouteObject, ScrollRestoration } from "react-router-dom";
import { Skeleton } from "antd";
import { lazy, Suspense } from "react";
import {
  Layout,
  SimpleLayout,
  SearchLayout,
  SearchLayoutWide,
  SimpleBusinessLayout,
  SimplePortalLayout,
  ProductDetailLayout,
  PlainLayout,
  HeaderFooterLayout,
  SingleTitleLayout,
  SearchLayoutEnterprise,
  GypHeaderFooterLayout,
} from "@/modules/layout";

export const SuspenseQutlet = () => {
  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <Skeleton loading={true} />
      <Skeleton loading={true} />
      <Skeleton loading={true} />
      <Skeleton loading={true} />
      <Skeleton loading={true} />
    </div>
  );
};

const SupplierProductPage = lazy(() =>
  import("@/pages/supplier-product").then((m) => ({
    default: m.SupplierProductPage,
  })),
);

const SupplierProductDetailPage = lazy(() =>
  import("@/pages/supplier-product-detail").then((m) => ({
    default: m.SupplierProductDetailPage,
  })),
);

const BussinessOpportunityPage = lazy(() =>
  import("@/pages/find-supplier/index").then((m) => ({
    default: m.BussinessOpportunityPage,
  })),
);

const AdvisePage = lazy(() =>
  import("@/pages/find-supplier/advise").then((m) => ({
    default: m.AdvisePage,
  })),
);

const BussinessCompanyPage = lazy(() =>
  import("@/pages/find-supplier/company").then((m) => ({
    default: m.BusinessCompany,
  })),
);

const EnterprisePage = lazy(() =>
  import("@/pages/findEnterprise").then((m) => ({
    default: m.FindEnterprise,
  })),
);

const EnterpriseSearchPage = lazy(() =>
  import("@/pages/enterpriseSearch").then((m) => ({
    default: m.default,
  })),
);

const ProjectPage = lazy(() =>
  import("@/pages/findProject").then((m) => ({
    default: m.FindProject,
  })),
);

const ProjectSearchPage = lazy(() =>
  import("@/pages/projectSearch").then((m) => ({
    default: m.ProjectSearchPage,
  })),
);

// const BusinessPage = lazy(() =>
//   import('@/pages/business').then((m) => ({ default: m.default }))
// );

const NoticePage = lazy(() =>
  import("@/pages/notice").then((m) => ({ default: m.default })),
);

const NoticeDetailPage = lazy(() =>
  import("@/pages/notice/detail").then((m) => ({ default: m.default })),
);

const NoticePageV1 = lazy(() =>
  import("@/pages/notice-v1").then((m) => ({ default: m.default })),
);
const NoticeDetailPageV1 = lazy(() =>
  import("@/pages/notice-v1/detail").then((m) => ({ default: m.default })),
);

const BusinessSearchPage = lazy(() =>
  import("@/pages/business/search").then((m) => ({ default: m.default })),
);

const TodaySearchPage = lazy(() =>
  import("@/pages/business/todaySearch").then((m) => ({ default: m.default })),
);

const AiSearchPage = lazy(() =>
  import("@/pages/business/aiSearch").then((m) => ({ default: m.default })),
);

const AiSearchSupplierPage = lazy(() =>
  import("@/pages/find-supplier/aiSearch").then((m) => ({
    default: m.default,
  })),
);

// const TenderDetailPage = lazy(() =>
//   import('@/pages/tender/detail').then((m) => ({ default: m.TenderDetailPage || m.default }))
// );

const BusinessListPage = lazy(() =>
  import("@/pages/businessList").then((m) => ({ default: m.default })),
);

const CompanyPortalPage = lazy(() =>
  import("@/pages/business-opportunity/business-opportunity").then((m) => ({
    default: m.BusinessOpportunityPage,
  })),
);
const ProjectDCompanyPortalPage = lazy(() =>
  import("@/components/projectD-company-portal-page").then((m) => ({
    default: m.ProjectDCompanyPortalPage,
  })),
);
const SearchResultPage = lazy(() =>
  import("@/pages/searchResult/searchResult").then((m) => ({
    default: m.default,
  })),
);

const BusinessDetailPage = lazy(() =>
  import("@/pages/business-detail").then((m) => ({
    default: m.default,
  })),
);

// const BusinessDetailPage = lazy(() =>
//   import("@/pages/business-detail").then((m) => ({
//     default: m.default,
//   }))
// );

const ProcurementNoticePage = lazy(() =>
  import("@/pages/procurementNotice/procurementNotice").then((m) => ({
    default: m.ProcurementNoticePage,
  })),
);
const ProcurementDetailPage = lazy(() =>
  import("@/pages/procurementNotice/procurementDetail").then((m) => ({
    default: m.ProcurementDetailPage,
  })),
);

// 询价详情
const InquiryDetailPage = lazy(() =>
  import("@/pages/inquiryDetail").then((m) => ({ default: m.default })),
);
// 竞价详情
const BiddingDetailPage = lazy(() =>
  import("@/pages/biddingdetail").then((m) => ({ default: m.default })),
);
// 招标详情
const TenderDetailPage = lazy(() =>
  import("@/pages/tenderDetail").then((m) => ({ default: m.default })),
);
// 招募单详情
const RecruitmentDetailPage = lazy(() =>
  import("@/pages/recruitmentDetail").then((m) => ({ default: m.default })),
);
// 招标公告详情
const TenderAnnouncementPage = lazy(() =>
  import("@/pages/tenderAnnouncementDetail").then((m) => ({
    default: m.default,
  })),
);

const RecommendPage = lazy(() =>
  import("@/pages/recommend").then((m) => ({ default: m.RecommendPage })),
);

const SubscriptionPage = lazy(() =>
  import("@/pages/subscription").then((m) => ({ default: m.SubscriptionPage })),
);

const SubscriptionManagePage = lazy(() =>
  import("@/pages/subscription/manage").then((m) => ({ default: m.default })),
);

const BecomeSupplierPage = lazy(() =>
  import("@/pages/becomeSupplier").then((m) => ({ default: m.default })),
);

const SupperSupplierPage = lazy(() =>
  import("@/pages/supperSupplier").then((m) => ({ default: m.default })),
);

const BecomeBuyerPage = lazy(() =>
  import("@/pages/becomeBuyer").then((m) => ({ default: m.default })),
);

const RightsAndInterestsPage = lazy(() =>
  import("@/pages/rights-and-interests").then((m) => ({ default: m.default })),
);

const UniteMemberYZPage = lazy(() =>
  import("@/pages/unite-member/yunzhu").then((m) => ({ default: m.default })),
);

const MemberBenefitsPage = lazy(() =>
  import("@/pages/memberBenefitsPage").then((m) => ({ default: m.default })),
);

const StewardPage = lazy(() =>
  import("@/pages/steward").then((m) => ({ default: m.default })),
);

const CaIntroductionPage = lazy(() =>
  import("@/pages/caIntroduction").then((m) => ({ default: m.default })),
);

const EGoodsContainInfoPage = lazy(() => import("@/pages/e-goods"));
const GoPreorder = lazy(() => import("@/pages/go-preorder"));
const GoCheckout = lazy(() => import("@/pages/go-checkOrder"));
const Go1688PaySuccessPage = lazy(() => import("@/pages/go1688-pay-success"));
const IframeQxPage = lazy(() => import("@/pages/qixin-page"));

const MapSearchPage = lazy(() =>
  import("@/pages/map-search").then((m) => ({ default: m.default })),
);


const NotFoundPage = lazy(() =>
  import("@/pages/404").then((m) => ({ default: m.NotFoundPage })),
);

const SUPPLIER_ORIGIN = process.env.SUPPLIER_ORIGIN;
const supplierDomain = SUPPLIER_ORIGIN?.split("://")[1];
const isSupplier =
  !!supplierDomain && window.location.hostname.includes(supplierDomain);

// 找商机路由配置
const BusinessRouter: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SearchLayout />
      </>
    ),
    children: [
      {
        path: "/go/search",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BusinessSearchPage />
          </Suspense>
        ),
      },
      {
        path: '/go/enterpriseSearch',
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <EnterpriseSearchPage />
          </Suspense>
        )
      },
      {
        path: "/go/projectSearch",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProjectSearchPage />
          </Suspense>
        ),
      },
      {
        path: "/go/todaySearch",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <TodaySearchPage />
          </Suspense>
        ),
      },
      {
        path: "/go/aiSearch",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <AiSearchPage />
          </Suspense>
        ),
      },
      {
        path: "/recommend",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <RecommendPage />
          </Suspense>
        ),
      },
      {
        path: "/subscription",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <SubscriptionPage />
          </Suspense>
        ),
      },
      {
        path: "/subscription/manage",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <SubscriptionManagePage />
          </Suspense>
        ),
      },
      {
        path: "/notice",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <NoticePage />
          </Suspense>
        ),
      },
      {
        path: "/notice_v1",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <NoticePageV1 />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SearchLayoutEnterprise />
      </>
    ),
    children: [
      {
        path:'/go/findEnterprise',
        element:(
          <Suspense fallback={<SuspenseQutlet />}>
            <EnterprisePage />
          </Suspense>
        )
      },
      {
        path: "/go/findProject",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProjectPage />
          </Suspense>
        ),
      },
    ]
  },
  // 商机详情
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SimpleBusinessLayout />
      </>
    ),
    children: [
      // 询价详情
      {
        path: "/business/inquiryDetail/:opportunityId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <InquiryDetailPage />
          </Suspense>
        ),
      },
      // 招募单详情
      {
        path: "/business/recruitmentDetail/:opportunityId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <RecruitmentDetailPage />
          </Suspense>
        ),
      },
      // 招标单详情
      {
        path: "/business/tenders/:opportunityId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <TenderDetailPage />
          </Suspense>
        ),
      },
      // 竞价单详情
      {
        path: "/business/bidDetail/:opportunityId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BiddingDetailPage />
          </Suspense>
        ),
      },
      // 所有的商机详情
      {
        path: "/go/detail/:opportunityId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BusinessDetailPage />
          </Suspense>
        ),
      },

      // 招标公告详情
      {
        path: "/business/tenderAnnouncement/:id/:source",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <TenderAnnouncementPage />
          </Suspense>
        ),
      },

      //公示详情
      {
        path: "/notice/:noticeId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <NoticeDetailPage />
          </Suspense>
        ),
      },
      {
        path: "/notice_v1/:noticeId",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <NoticeDetailPageV1 />
          </Suspense>
        ),
      },
    ],
  },

  // 项目门户
  {
    path: "/projectDetail/:projectKey",
    element: (
      <>
        <ScrollRestoration />
        <ProductDetailLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProjectDCompanyPortalPage />
          </Suspense>
        ),
      },
    ],
  },
  // 门户
  {
    path: "/company",
    element: (
      <>
        <ScrollRestoration />
        <SimplePortalLayout />
      </>
    ),
    children: [
      // 门户
      {
        index: true,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <CompanyPortalPage />
          </Suspense>
        ),
      },
      // 企业内搜索
      {
        path: "search",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <SearchResultPage />
          </Suspense>
        ),
      },
      // 采购公告列表
      {
        path: "notice",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProcurementNoticePage />
          </Suspense>
        ),
      },
      // 采购公告详情
      {
        path: "notice/:id",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProcurementDetailPage />
          </Suspense>
        ),
      },
      {
        path: "*",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <div>404</div>
          </Suspense>
        ),
      },
    ],
  },
  // 门户 兼容旧路由
  {
    path: "/portal",
    element: (
      <>
        <ScrollRestoration />
        <SimplePortalLayout />
      </>
    ),
    children: [
      // 门户
      {
        index: true,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <CompanyPortalPage />
          </Suspense>
        ),
      },
      // 企业内搜索
      {
        path: "search",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <SearchResultPage />
          </Suspense>
        ),
      },
      // 采购公告列表
      {
        path: "notice",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProcurementNoticePage />
          </Suspense>
        ),
      },
      // 采购公告详情
      {
        path: "notice/:id",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <ProcurementDetailPage />
          </Suspense>
        ),
      },
    ],
  },
];

// 找供应商路由配置
const SupplierRouter: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SearchLayout />
      </>
    ),
    children: [
      // 供应商搜索页面
      {
        path: "/s/search",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BussinessOpportunityPage />
          </Suspense>
        ),
      },
      // AI搜索页面
      {
        path: "/s/aiSearch",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <AiSearchSupplierPage />
          </Suspense>
        ),
      },

      //供应商专题页
      {
        path: "/s/advise",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <AdvisePage />
          </Suspense>
        ),
      },
      //供应商专题页
      // delete 这里是为了兼容就的path
      {
        path: "/find-supplier/advise",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <AdvisePage />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SimpleLayout />
      </>
    ),
    children: [
      // 供应商详情
      {
        path: "/supplier/:id",
        index: false,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BussinessCompanyPage />
          </Suspense>
        ),
      },
      // 商品详情页面
      {
        path: "/product/:id",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<SuspenseQutlet />}>
                <SupplierProductPage />
              </Suspense>
            ),
          },
          {
            path: ":productId",
            element: (
              <Suspense fallback={<SuspenseQutlet />}>
                <SupplierProductDetailPage />
              </Suspense>
            ),
          },
        ],
      },
      // {
      //   path: "/notice",
      //   element: (
      //     <Suspense fallback={<SuspenseQutlet />}>
      //       <NoticePage />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "/notice/:id",
      //   element: (
      //     <Suspense fallback={<SuspenseQutlet />}>
      //       <NoticeDetailPage />
      //     </Suspense>
      //   ),
      // },
      {
        path: "/tender/:id",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <TenderDetailPage />
          </Suspense>
        ),
      },
    ],
  },
];

// 基础路由配置
const BaseRouter: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <Layout />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            {
              // 找商机 如果是供应商，则跳转到供应商专题页
              isSupplier ? <BussinessOpportunityPage /> : <BusinessListPage />
            }
          </Suspense>
        ),
      },
      {
        path: "/go",
        element: (
          // 找商机
          <Suspense fallback={<SuspenseQutlet />}>
            <BusinessListPage />
          </Suspense>
        ),
      },
      {
        path: "/s",
        index: false,
        element: (
          // 找供应商
          <Suspense fallback={<SuspenseQutlet />}>
            <BussinessOpportunityPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <HeaderFooterLayout />
      </>
    ),
    children: [
      {
        path: "/rights-and-interests",
        element: (
          // 权益中心
          <Suspense fallback={<SuspenseQutlet />}>
            <RightsAndInterestsPage />
          </Suspense>
        ),
      },
      {
        path: "/unite-member",
        element: (
          // 云筑蜜蜂PLUS 联名会员
          <Suspense fallback={<SuspenseQutlet />}>
            <UniteMemberYZPage />
          </Suspense>
        ),
      },
      // 联合会员权益页面
      {
        path: "/e-goods",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <EGoodsContainInfoPage />
          </Suspense>
        ),
      },
      // 企信页面
      {
        path: "/qixin_page",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <IframeQxPage />
          </Suspense>
        ),
      },
      // 地图找商机
      {
        path: "/mapSearch",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <MapSearchPage />
          </Suspense>
        ),
      },
      {
        path: "/preorder",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <GoPreorder />
          </Suspense>
        ),
      },
      {
        path: "/checkorder",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <GoCheckout />
          </Suspense>
        ),
      },
      {
        path: "/pay-success",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <Go1688PaySuccessPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SearchLayoutWide />
      </>
    ),
    children: [
      {
        path: "/caIntroduction",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <CaIntroductionPage />
          </Suspense>
        ),
      },
      {
        path: "/become-supplier",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BecomeSupplierPage />
          </Suspense>
        ),
      },
      {
        path: "/supperSupplier",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <SupperSupplierPage />
          </Suspense>
        ),
      },
      {
        path: "/become-buyer",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <BecomeBuyerPage />
          </Suspense>
        ),
      },
      {
        path: "/steward",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <StewardPage />
          </Suspense>
        ),
      },
    ],
  },
  // 订阅页面 用于工作台的iframe内嵌
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <PlainLayout />
      </>
    ),
    children: [
      {
        path: "/subscriptionIframe",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            {/* <EGoodsPage /> */}
            <div style={{ width: "1200px", margin: "0 auto" }}>
              <SubscriptionPage />
            </div>
          </Suspense>
        ),
      },
      {
        path: "/subscriptionIframe/manage",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <div style={{ width: "1200px", margin: "0 auto" }}>
              <SubscriptionManagePage />
            </div>
          </Suspense>
        ),
      },
      {
        path: "/recommendIframe",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            {/* <EGoodsPage /> */}
            <div style={{ width: "1200px", margin: "0 auto" }}>
              <RecommendPage />
            </div>
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <SingleTitleLayout />
      </>
    ),
    children: [
      {
        path: "/memberBenefits",
        element: (
          <Suspense fallback={<SuspenseQutlet />}>
            <MemberBenefitsPage />
          </Suspense>
        ),
      },
    ],
  },
  // 404
  {
    path: "*",
    element: (
      <Suspense fallback={<SuspenseQutlet />}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

/**
 * 根路由 禁止使用 /go/portal 和 /buyer的路径 ，这两个网关已经转发到其他的前端工程了
 */
export const routes: RouteObject[] = [
  ...BusinessRouter,
  ...SupplierRouter,
  ...BaseRouter,
];
